
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flexible-gift-cards",
      function () {
        return require("private-next-pages/flexible-gift-cards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flexible-gift-cards"])
      });
    }
  